// Хранилище токенов авторизации.
//
// РЕШЕНИЕ ПО БЕЗОПАСНОСТИ (ТЗ §8, нефункциональные требования):
// - Access-токен хранится ИСКЛЮЧИТЕЛЬНО в памяти (модульная переменная ниже) и никогда
//   не попадает в localStorage/sessionStorage — это снижает риск его кражи через XSS
//   (утечка возможна только пока страница открыта, токен живёт всего 15 минут).
// - Refresh-токен в проде правильно хранить в httpOnly-cookie, недоступной для JS.
//   Но это SPA без собственного backend-for-frontend/SSR, которое отдаёт HTML статикой
//   (Vite dev/preview или nginx), поэтому backend не может выставить httpOnly-cookie
//   для этого домена в рамках прототипа. Реалистичный компромисс для демо-прототипа —
//   хранить refresh-токен в localStorage, чтобы пользователь не терял сессию при
//   обновлении страницы. В продакшене это МЕСТО НУЖНО заменить на httpOnly-cookie,
//   выставляемую backend'ом при логине, и убрать localStorage-хранение ниже.

const REFRESH_TOKEN_KEY = "proschool.refreshToken";

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token: string | null): void {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
}

export function clearTokens(): void {
  setAccessToken(null);
  setRefreshToken(null);
}

type UnauthorizedListener = () => void;
let unauthorizedListener: UnauthorizedListener | null = null;

export function onUnauthorized(listener: UnauthorizedListener): void {
  unauthorizedListener = listener;
}

export function notifyUnauthorized(): void {
  unauthorizedListener?.();
}
